// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label  [data-v-64f8fd26-slot]>a,.label ::slotted(a) {\n  color: var(--magic-secondary, #7b6aff) !important;\n  font-weight: 900 !important;\n}", ""]);
// Exports
module.exports = exports;
